import { useState } from "react";
import { IconButton, Typography } from "@mui/material";
import { T } from "../../../util/t";
import { Close } from "@mui/icons-material";
import { makeStyles } from "../../../providers/makeStyles";

const seriesNotFoundNotificationStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.info.light
    }
}));

export const RankingNotFoundNotification = ({ rankingNotFound=false }) => {
    const [show, setShow] = useState(rankingNotFound);
    const classes = seriesNotFoundNotificationStyles();

    const closeNotification = () => {
        setShow(false);
    };

    return (show && <div className={classes.root}>
        <Typography><T>Looking for a different ranking? Select a different series or division below.</T></Typography>
        <IconButton color="inherit" size="small" onClick={closeNotification}><Close/></IconButton>
    </div>);
};
